import React, { useContext, useEffect } from 'react';
import { GetLookupItemsByLookupTypeName } from '../../../Services';
import { useCallback } from 'react';

const CreateLeadContext = React.createContext({
  initialStatus: {},
  initialStage: {},
  methodOfContact: {},
  leadTypes: [],
  leadOwnerType: {},
});

export const useCreateLeadContext = () => useContext(CreateLeadContext);

const CreateLeadContextProvider = ({ children }) => {
  const [status, setStatus] = React.useState({});
  const [stage, setStage] = React.useState({});
  const [leadOwnerType, setLeadOwnerType] = React.useState({});
  const [methodOfContact, setMethodOfContact] = React.useState({});
  const getInitialStatus = async () => {
    const res = await GetLookupItemsByLookupTypeName({
      lookUpName: 'LeadStatus',
      pageIndex: 1,
      pageSize: 10000,
    });
    if ('result' in res && Array.isArray(res.result)) {
      setStatus(
        res.result.find((item) => item.lookupItemName.toLowerCase() === 'open')
      );
    }
  };

  const getInitialStage = useCallback(async () => {
    const res = await GetLookupItemsByLookupTypeName({
      lookUpName: 'LeadStage',
      pageIndex: 1,
      pageSize: 10000,
    });
    if ('result' in res && Array.isArray(res.result)) {
      setStage(
        res.result.find((item) => item.lookupItemName.toLowerCase() === 'new')
      );
    }
  }, []);
  const getLeadOwnerType = useCallback(async () => {
    const res = await GetLookupItemsByLookupTypeName({
      lookUpName: 'LeadOwnerType',
      pageIndex: 1,
      pageSize: 10000,
    });
    if ('result' in res && Array.isArray(res.result)) {
      setLeadOwnerType(
        res.result.find((item) => item.lookupItemName.toLowerCase() === 'owner')
      );
    }
  }, []);

  const getMethodOfContact = useCallback(async () => {
    const res = await GetLookupItemsByLookupTypeName({
      lookUpName: 'MethodOfContact',
      pageIndex: 1,
      pageSize: 10000,
    });
    if ('result' in res && Array.isArray(res.result)) {
      setMethodOfContact(
        res.result.find(
          (item) => item.lookupItemName.toLowerCase() === 'partner hub'
        )
      );
    }
  }, []);
  useEffect(() => {
    getInitialStatus();
    getInitialStage();
    getLeadOwnerType();
    getMethodOfContact();
  }, []);
  return (
    <CreateLeadContext.Provider
      value={{
        initialStatus: status,
        initialStage: stage,
        leadTypes: [],
        methodOfContact,
        leadOwnerType,
      }}
    >
      {children}
    </CreateLeadContext.Provider>
  );
};

export default CreateLeadContextProvider;
